<template>
  <div class="share-container">
    <div class="title">基本信息</div>
    <div class="info-list">
      <div class="info-item">
        <span class="item-label">订单号</span>
        <span class="item-value">{{detail.orderNum}}</span>
      </div>
      <div class="info-item">
        <span class="item-label">订单创建人</span>
        <span class="item-value">{{detail.createName}}</span>
      </div>
      <div class="info-item">
        <span class="item-label">下单时间</span>
        <span class="item-value">{{detail.createTime | rTime}}</span>
      </div>
      <div class="info-item">
        <span class="item-label">关联用户</span>
        <span class="item-value">{{detail.connectName}}</span>
      </div>
      <div class="info-item">
        <span class="item-label">课题组</span>
        <span class="item-value">{{detail.groupName}}</span>
      </div>
<!--      <div class="info-item">-->
<!--        <span class="item-label">优惠系数</span>-->
<!--        <span class="item-value">{{detail.discount}}</span>-->
<!--      </div>-->
      <div class="info-item">
        <span class="item-label">商品数量</span>
        <span class="item-value">{{detail.count}}</span>
      </div>
      <div class="info-item">
        <span class="item-label">配送方式</span>
        <span class="item-value">{{detail.sendType}}</span>
      </div>
      <div class="info-item">
        <span class="item-label">地址</span>
        <span class="item-value">{{detail.address}}</span>
      </div>
      <div class="info-item">
        <span class="item-label">备注</span>
        <span class="item-value">{{detail.remark}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
.share-container {
  background-color: #fff;
  .title {
    font-size: 16px;
    font-weight: 600;
    margin-top: 2vh;
    margin-left: 4vw;
    border-left: 2vw solid #014492;
    padding-left: 2vw;
    color: #1d2c36;
  }
  .info-list {
    padding: 1.8vh 8vw 1.5vh;
    .info-item {
      font-size: 14px;
      padding: 0.75vh 0;
      .item-label {
        display: inline-block;
        min-width: 18.7vw;
        margin-right: 4vw;
        color: rgba(#1d2c36, 0.5);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/share/confirm-order/components/OrderBaseInfo.vue